'use client';

import React, { useMemo, useState } from 'react';
import DropdownContext from './_dropdownContext';

interface Props {
  children: React.ReactNode;
}

export default function DropdownProvider({ children }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const values = useMemo(() => ({ isOpen, setIsOpen }), [isOpen]);
  return <DropdownContext.Provider value={values}>{children}</DropdownContext.Provider>;
}
